const getters = {
	/**
	 * Retorna se possui eixos e engrenagens.
	 */
	hasGearsAndShafts(state)
	{
		const hasValidGearboxStages = state.gearboxStages.some(gear => gear.name !== "");
		const hasValidShafts = state.shafts.some(shaft => shaft.name !== "");

		return !(hasValidGearboxStages && hasValidShafts);
	},

	/**
   * Retorna true se todas as validações de configuração estiverem válidas.
   * @param {Object} state - O estado do módulo.
   * @returns {boolean}
   */
	isConfigurationValid(state)
	{
		return (
			state.turbinePropertiesValid &&
      state.gearboxPropertiesValid &&
      state.shaftPropertiesValid &&
      state.gearsPropertiesValid &&
      state.gearMeshFrequencyPropertiesValid &&
      state.effectiveSincePropertiesValid
		);
	},

	/**
   * Retorna os itens de eixo.
   */
	shaftItems(state)
	{
		return state.shafts;
	},

	/**
   * Retorna os estágios da caixa de engrenagem.
   */
	gearboxStages(state)
	{
		return state.gearboxStages;
	}
};

export default { getters };